module.exports = __webpack_public_path__ + "img/wine-tasting.d720b2cb.jpg";